import React, { useEffect } from "react";
import { Form, Input, Button, Select, FormInstance } from "antd";
import { Device } from "../../../types/device";
import { useGetAllProductQuery } from "../../../services/product";

interface DeviceFormProps {
  initialValues: Device;
  onSubmit: (values: Device) => void;
  form: FormInstance<any>;
}

const DeviceForm: React.FC<DeviceFormProps> = ({ initialValues, onSubmit,form }) => {
  const { data: products, error, isLoading } = useGetAllProductQuery();

  const allProduct = products?.map((product) => {
    return {
      value: product._id,
      label: product.product_name,
    };
  });
  const onSearchDeviceId = (value: string) => {
  };
  useEffect(() => {
    if (initialValues) {
      form.setFieldsValue(initialValues);
    } else {
      form.resetFields();
    }
  }, [initialValues, form]);
  return (
    <Form form={form} initialValues={initialValues} onFinish={onSubmit}
      labelCol={{ span: 6 }}
      wrapperCol={{ span: 18 }}
    >
      <Form.Item
        name="hardware_id"
        label="Hard Ware ID"
        rules={[
          {
            required: true,
            message: "Vui lòng không để trống Hardware ID",
          },
        ]}
      >
        <Input />
      </Form.Item>
      <Form.Item
        name="device_name"
        label="Tên thiết bị"
        rules={[
          {
            required: true,
            message: "Vui lòng không để trống tên thiết bị",
          },
        ]}
      >
        <Input />
      </Form.Item>
      <Form.Item name="product_id" 
      label="Sản phẩm"
      rules={[
        {
          required: true,
          message: "Vui lòng chọn thiết bị!",
        },
      ]}
      >
        <Select
          showSearch
          placeholder="Chọn sản phẩm"
          optionFilterProp="label"
          onSearch={onSearchDeviceId}
          options={allProduct}
        />
      </Form.Item>
      <Form.Item label={null}>
        <Button type="primary" htmlType="submit">
          Lưu
        </Button>
      </Form.Item>
    </Form>
  );
};

export default DeviceForm;
